import { useQuery } from 'react-query';
import getCapitalStatusHandler from 'API/handlers/getCapitalStatus';

const useCapitalApi = () => {
  const {
    data: enrollmentStatus,
    isError,
    isLoading,
  } = useQuery({
    queryKey: ['GUESTY-CAPITAL'],
    queryFn: () => getCapitalStatusHandler(),
  });

  return {
    isCapitalEnabled:
      !isError && !isLoading && enrollmentStatus !== 'not_eligible',
  };
};

export default useCapitalApi;
